import request from 'Request'

const GroupService = {
  async list({ appCodes } = {}) {
    return request.post('/groups/list', { appCodes })
  }
}

export default GroupService
